import { GET_BADGES,ADD_BADGES, UPDATE_BADGES, DELETE_BADGES } from '../actions/actionTypes';

const initialState = {
  badgeData:[],badgescardItemData:[],badgestotalCount:0,badgescardData:[],cardItemDataShow:false,opentost:false,tost_msg:''
};

function checkdate (data)  {
  let enddate =false;
let date1 =   JSON.parse(data).issueDate;

  console.log('date1',date1);

  return date1;
}


export default function courses(state = initialState, action) {

  switch (action.type) {
     case GET_BADGES:
      
      return{
       ...state,
       badgeData: action.badgeData,
       badgescardData: action.getCardData,
       badgestotalCount:action.totalCount,
       badgescardItemData:action.cardItemData,
       cardItemDataShow:action.cardItemDataShow
      

      };
     case ADD_BADGES:
        if(!action.newlyAddedBadge) {
          //badge could not be created, just return back the state
          return {
            ...state
          }
        }


        let updatedBadges = state.badgescardItemData
        updatedBadges.push(action.newlyAddedBadge)

        let totalCount=0;
        let finaldata=[];
        let setCardItemDataShow=false;

        totalCount = updatedBadges.length

        let getCardItemData = updatedBadges.filter(item => item._deleted !== true).sort((a, b) => b.createdAt.localeCompare(a.createdAt));

        if(totalCount > 3) {
          setCardItemDataShow = true
        }

        if(getCardItemData.length > 0) {
          for (let i = 0; i < getCardItemData.length; i++) {
            const data = getCardItemData[i].newdata;
            let datecheck = checkdate(data);
  
            getCardItemData[i]['datecheck'] = datecheck;
  
            //restricted i.e. if education is publically viewable logic goes here. Add that logic if needed
  
            ///handling logic
          }
        }

        let getCardItemData2 = getCardItemData.sort((a, b) => Date.parse(b.datecheck) - Date.parse(a.datecheck))


        finaldata = getCardItemData2

      
        return{
          ...state,
          opentost:action.opentost,
          tost_msg:action.tost_msg,
          badgescardItemData: finaldata,
          badgestotalCount: totalCount,
          cardItemDataShow: setCardItemDataShow,
          badgescardData: action.getCardData
        };
     case UPDATE_BADGES: 
     if(!action.updatedBadgeItem) {
      //badge update was NOT successfull, just return back the state
      return {
        ...state
      }
     }

     const matchingBadgeItemIndex = state.badgescardItemData.findIndex(badgeItem => badgeItem.id === action.updatedBadgeItem.id)

    //  let sortedBadges = []
    //  let unSortedBadges = []
     if(matchingBadgeItemIndex !== -1) {
      state.badgescardItemData[matchingBadgeItemIndex] = action.updatedBadgeItem

      //sort the items as well, since date will also change, do it later
      // unSortedBadges = state.badgescardItemData

      // sortedBadges = unSortedBadges.sort((itemA, itemB) => {
      //   Date.parse(JSON.parse(itemB.newdata).issueDate) - Date.parse(JSON.parse(itemA.newdata).issueDate)
      // })
     }

     return {
      ...state,
      // badgescardItemData: sortedBadges
     }

     case DELETE_BADGES: 

      if(action.deleteSuccess) {
        const badgesAfterDelete = action.badgeCardItemData

        let totalCountAfterDelete=0;
        let finaldataAfterDelete=[];
        let setCardItemDataShowAfterDelete=false;

        totalCountAfterDelete = badgesAfterDelete.length

        let cardItemsData = badgesAfterDelete.filter(item => item._deleted !== true).sort((a, b) => b.createdAt.localeCompare(a.createdAt));

        if(totalCountAfterDelete > 3) {
          setCardItemDataShowAfterDelete = true
        }
        
        if(cardItemsData.length > 0) {
          for (let i = 0; i < cardItemsData.length; i++) {
            const data = cardItemsData[i].newdata;
            let datecheck = checkdate(data);
  
            cardItemsData[i]['datecheck'] = datecheck;
          }
        }

        let cardItemsData2 = cardItemsData.sort((a, b) => Date.parse(b.datecheck) - Date.parse(a.datecheck))

        finaldataAfterDelete = cardItemsData2

        return {
          ...state,
          badgescardItemData: finaldataAfterDelete,
          badgestotalCount: totalCountAfterDelete,
          cardItemDataShow: setCardItemDataShowAfterDelete
        }

      } else {
        //badge delete was not successfull, just return back the state
        return {
          ...state
        }
      }

     default: return state;
  }
};

